const STATUS_LABELS: Record<string, string> = {
  draft: 'Rascunho',
  pending: 'Pendente',
  scheduled: 'Agendado',
  active: 'Ativo',
  rejected: 'Rejeitado',
  closed: 'Encerrado',
  finished: 'Finalizado',
};

const CHALLENGE_TYPE_LABELS: Record<string, string> = {
  personal_record: 'Recorde Pessoal',
  calories: 'Calorias',
  distance: 'Distância',
  time: 'Tempo',
  checkins: 'Check-ins',
};

const STATUS_BADGE_CLASS: Record<string, string> = {
  draft: 'challenges-badge--muted',
  pending: 'challenges-badge--warning',
  scheduled: 'challenges-badge--info',
  active: 'challenges-badge--success',
  rejected: 'challenges-badge--danger',
  closed: 'challenges-badge--muted',
  finished: 'challenges-badge--primary',
};

export function getStatusLabel(status: string): string {
  return STATUS_LABELS[status] ?? status;
}

export function getChallengeTypeLabel(challengeType: string): string {
  return CHALLENGE_TYPE_LABELS[challengeType] ?? challengeType;
}

export function getStatusBadgeClass(status: string): string {
  return STATUS_BADGE_CLASS[status] ?? 'challenges-badge--muted';
}
